/* eslint-disable no-unused-vars -- does not support ts */
export const snakeCaseToCamelCase = (str: string) => str.replace(/_+(.?)/g, (_, p1) => p1.toUpperCase())
export const camelCaseToSnakeCase = (str: string) => str.replace(/([A-Z])/g, $p1 => '_' + $p1.toLowerCase())

const propertyNameConverter = (converter: (str: string) => string, object: any): object => {
  if (typeof object !== 'object') return object

  for (const oldKey in object) {
    const newKey = converter(oldKey)

    if (newKey !== oldKey) {
      if (object.hasOwnProperty(oldKey)) {
        object[newKey] = object[oldKey]
        delete object[oldKey]
      }
    }

    if (typeof object[newKey] === 'object') {
      object[newKey] = propertyNameConverter(converter, object[newKey])
    }
  }
  return object
}

/**
 * Converting the camel case object keys to snake case
 */
export const camelCaseObjectKeysToSnakeCase = (object: object) => propertyNameConverter(camelCaseToSnakeCase, object)

/**
 * Converting the snake case object keys to camel case
 */
export const snakeCaseObjectKeysToCamelCase = (object: object) => propertyNameConverter(snakeCaseToCamelCase, object)
